import React, { useContext, useEffect, useState } from 'react';
import MapViewForDataFD from 'components/FDMapView/MapViewForDataFD';
import NavBar from 'components/NavBar';
import { useAuthContextState, useAuthContext } from 'contexts/Auth';
import { BusinessIcon, UserCircleIcon, LogoutIcon } from 'utils/icons';
import { Link, useLocation, useHistory, useParams } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import signOut from 'helpers/signOut';
import ProcessedFdData from 'components/FDMapView/ProcessedFdData';

import {
  getSubscriptionFdData,
  getSubscriptionDataById,
} from 'api/fieldDelineation/subscriptions';
import { useQuery } from '@tanstack/react-query';
import { BackArrowIcon } from 'icons';
import styles from './mapview.module.css';

const ViewFDSubscriptionsData = () => {
  const urlLocation = useLocation();
  const { subscriptionId } = useParams();

  const [name, setName] = useState(null);
  const [pageIndex, setPageIndex] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [subscriptionData, setSubscriptionData] = useState(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(urlLocation.search);
    setName(queryParams.get('name'));
  }, [urlLocation]);

  useEffect(() => {
    const fetchSubscriptionData = async () => {
      if (subscriptionId) {
        try {
          const data = await getSubscriptionDataById({ subscriptionId });
          setSubscriptionData(data);
          // console.log('Subscription Data:', data);
        } catch (error) {
          console.error('Error fetching subscription data:', error);
        }
      }
    };

    fetchSubscriptionData();
  }, [subscriptionId]);

  // Extract zoom from url parameters when the window loads
  const initialZoom = window.location.hash
    ? window.location.hash.substr(1).split('/')[0]
    : 13;
  const [zoom, setZoom] = useState(initialZoom);
  const [toggleLeftDrawer, setToggleLeftDrawer] = useState(false);
  const [isRightDrawerOpen, setIsRightDrawerOpen] = useState(true);

  const toggleRightDrawer = () => {
    setIsRightDrawerOpen(!isRightDrawerOpen);
  };

  const { isLoading, error, data } = useQuery(
    ['subscriptionFdData', subscriptionId, pageIndex, pageSize],
    async () => {
      const FdDataList = await getSubscriptionFdData({
        subscriptionId,
        page: pageIndex,
        limit: pageSize,
      });

      if (Array.isArray(FdDataList)) {
        return FdDataList;
      }

      return [];
    },
    {
      enabled: !!subscriptionId,
      refetchInterval: 5000,
      refetchIntervalInBackground: false,
    }
  );

  return (
    <div>
      <NavBar Title={name} />
      <div className={styles.dashboardRoot}>
        <div className={styles.rightPanel}>
          <Link
            className={styles.backToProjectsContainer}
            to="/delineated-fields/subscriptions"
          >
            <BackArrowIcon className="icon-root" />
            <div>Back to Orders</div>
          </Link>

          <div className={styles.mainDashboard}>
            <div className="map-and-drawer">
              {isLoading && (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh', // Full viewport height
                    width: '100vw', // Full viewport width
                    position: 'fixed', // Fix position to the viewport
                    top: 0, // Align to the top
                    left: 0, // Align to the left
                    backgroundColor: 'rgba(255, 255, 255, 0.8)', // Optional: Add a semi-transparent background
                    zIndex: 1000, // Ensure it is above other content
                  }}
                >
                  <CircularProgress />
                </Box>
              )}
              {error && <div>Error loading data</div>}
              {!isLoading && !error && (
                <>
                  <MapViewForDataFD data={data} />
                  <ProcessedFdData
                    open
                    onClose={() => {}}
                    fdData={data} // Pass subscription field data
                    subscriptionData={subscriptionData} // Pass subscription data by ID
                    error={error}
                    isLoading={isLoading}
                    setQueryPageIndex={setPageIndex}
                    setQueryPageSize={setPageSize}
                    queryPageIndex={pageIndex}
                    queryPageSize={pageSize}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewFDSubscriptionsData;
